/* eslint-disable class-methods-use-this */
import axios from "axios";
import merge from "deepmerge";

// Internal components
const API_URL = process.env.REACT_APP_API_URL;

export default class BaseApi {
  async fetchData(rq) {
    try {
      const axiosRq = {
        baseURL: API_URL,
        method: "get",
        responseType: "json",
        headers: {
          "Content-Type": "application/json",
        },
        validateStatus: () => true,
      };

      if (rq.url === undefined) {
        axiosRq.transformResponse = [
          function (data) {
            // Do whatever you want to transform the data
            return data;
          },
        ];
      }

      const isFormData = rq.data instanceof FormData;

      if (typeof rq.data !== "undefined") {
        axiosRq.method = "post";
        // if (!isFormData) {
        //   rq.data = rq.data;
        // }
      }

      if (isFormData) {
        const apiUrl = rq.url ? rq.url : "";
        if (!apiUrl) {
          return new Promise((resolve, reject) => {
            reject(Error("Could not find url"));
          });
        }
         return axios.post(apiUrl, rq.data, {
          baseURL: API_URL,
          headers: {
            ...rq.headers,
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
          responseType: "json",
          validateStatus: () => true,
        }).then(response => {
           if (response.status === 401 || (response.data && response.data.message === "Unauthorized: Invalid token")) {
            localStorage.clear();
            window.location.href = "/login";
            return Promise.reject(response);
          } 
          return response;
        }); 
      }
      return axios(merge(axiosRq, rq)).then(response => {
        if (response.status === 401 || (response.data && response.data.message === "Unauthorized: Invalid token")) {
          localStorage.clear();
          window.location.href = "/login";
          return Promise.reject(response);
        }
        return response;
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("errorbase", error);
    }
    return new Promise((resolve, reject) => {
      reject(Error("Could not execute"));
    });
  }
}
